// Entry point: register the components, apply the theme before first paint, then load the shell
// bootstrap and let the router render.

import './components/app-root.js';
import './components/app-router.js';
import './components/app-nav.js';
import './components/run-banner.js';
import './components/filter-bar.js';
import './components/data-table.js';
import './components/chart-frame.js';
import './components/chart-legend.js';
import './components/chart-tooltip.js';
import './components/status-badge.js';
import './components/demand-ribbon.js';
import './components/capacity-bridge.js';
import './components/dashboard-summary.js';
import './components/capacity-heatmap.js';
import './components/bullet-rows.js';
import './components/small-multiples.js';
import './components/horizon-chart.js';
import './components/beeswarm-chart.js';
import './components/mosaic-chart.js';
import './components/bump-chart.js';
import './components/project-timeline.js';
import './components/assignment-matrix.js';
import './components/contention-map.js';
import './components/source-flow.js';
import './components/sensitivity-tornado.js';
import './components/decision-calendar.js';
import './components/remedy-lead-times.js';
import './components/bench-forecast.js';
import './components/fan-chart.js';
import './components/opportunity-funnel.js';
import './components/snapshot-changes.js';
import './components/project-intelligence.js';
import './components/project-list.js';
import './components/person-view.js';
import './components/person-list.js';
import './components/scenario-list.js';
import './components/scenario-editor.js';
import './components/hygiene-worklist.js';
import './components/digest-subscription.js';
import './components/quality-metrics.js';
import './components/pages.js';
import './components/estimate-strip.js';
import './components/estimate-hygiene.js';
import './components/estimate-settings.js';
import './components/estimate-rate-sheets.js';
import './components/estimate-analogs.js';
import './components/estimate-list.js';
import './components/estimate-editor.js';
import './components/estimate-schedule.js';
import './components/estimate-deal-list.js';
import './components/estimate-deal.js';
import './components/estimate-template-list.js';
import './components/estimate-template-designer.js';
import './components/estimate-pages.js';
import './components/page-styleguide.js';

import { store, applyTheme } from './store.js';
import { api, ApiError, setUnauthenticatedHandler } from './api.js';

applyTheme();

setUnauthenticatedHandler(() => {
  // The session went away (expired, revoked, signed out in another tab). Drop to the sign-in
  // card rather than leaving stale numbers on screen.
  store.set({ user: null, ready: true });
});

async function bootstrap() {
  try {
    const data = await api.get('/app/bootstrap');
    store.set({
      ready: true,
      error: null,
      user: data.user,
      scope: data.scope,
      run: data.run,
      runs: data.runs,
      scenarios: data.scenarios ?? [],
      sources: data.sources,
      vocabularies: data.filters,
      palette: data.palette.types,
      settings: data.settings,
      tools: data.tools ?? [],
    });
  } catch (err) {
    const unauthenticated = err instanceof ApiError && err.status === 401;
    store.set({
      ready: true,
      user: null,
      error: unauthenticated ? null : `Could not load the shell: ${err.message}`,
    });
  }
}

bootstrap();
